import { Flex, Spinner } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import { lazy, Suspense } from "react"

const TechnologyFlowListPage = lazy(
  () =>
    import(
      "../../../../../components/WMS/Technologies/Flows/TechnologyFlowListPage"
    ),
)

export const Route = createFileRoute("/_layout/WMS/technologies/flows/")({
  component: LazyFlowsListPage,
})

function LazyFlowsListPage() {
  return (
    <Suspense
      fallback={
        <Flex h="full" w="full" align="center" justify="center" py={12}>
          <Spinner size="lg" />
        </Flex>
      }
    >
      <TechnologyFlowListPage />
    </Suspense>
  )
}
